module.exports = __webpack_public_path__ + "img/how-we-work.0a8097ae.png";